module.exports = __webpack_public_path__ + "static/media/delete-button-white.f3c0b91b.svg";